import { render } from "./culturalFb1.vue?vue&type=template&id=f431b7e2&scoped=true"
import script from "./culturalFb1.vue?vue&type=script&lang=js"
export * from "./culturalFb1.vue?vue&type=script&lang=js"

import "./culturalFb1.vue?vue&type=style&index=0&id=f431b7e2&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f431b7e2"]])

export default __exports__